import React from "react";

// Styling
import { makeStyles } from "@material-ui/core/styles";

// Components
import { CircularProgress, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  progressContainer: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
  },
}));

const FullContainerProgress = ({ label = "" }) => {
  // Styles
  const classes = useStyles();
  return (
    <div className={classes.progressContainer}>
      <CircularProgress />
      <Typography
        variant="h6"
        gutterBottom
        align="center"
        style={{ marginTop: "1rem" }}
      >
        {label}
      </Typography>
    </div>
  );
};

export default FullContainerProgress;
